// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2jaSB","label":"Labeled_label__1SpXv","divider":"Labeled_divider__355bc"};